import { useSelector } from 'react-redux';
import { schema, normalize } from 'normalizr';
import merge from 'lodash/fp/merge';

import { getLogos } from './selectors';

// Constants
export const ENTITIES_KEY_LOGO = 'logos';

export const SET_LOGOS = 'entities/SET_LOGOS';

// Schemas
export const logo = new schema.Entity('logos');

export const logoList = [logo];

const normalizeLogos = (logos) => normalize(logos, logoList);

const getEntitiesToMerge = (normalizedLogos) =>
    merge(
        {
            entities: {
                [ENTITIES_KEY_LOGO]: {
                    allIds: normalizedLogos.result,
                },
            },
        },
        normalizedLogos,
    );

// Hooks
export function useLogos() {
    return useSelector(getLogos);
}

// Actions
export const setLogos = (logos) => ({
    type: SET_LOGOS,
    payload: getEntitiesToMerge(normalizeLogos(logos)),
});
